import { useEffect, useState } from "react";
import { getLocationAccessToken } from "../../../services/attendanceService";

const API_URL = "https://us1.locationiq.com/v1/reverse.php";

export function useLocalityDisplay(latitude, longitude) {
  const [locality, setLocality] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [error, setError] = useState(null);

  useEffect(() => {
    if (latitude === null || longitude === null) {
      setStatus("idle");
      setLocality("");
      setError(null);
      return;
    }
    let cancelled = false;
    setStatus("loading");
    setError(null);

    getLocationAccessToken()
      .then((token) => {
        const key = typeof token === "string" ? token : token?.message;
        if (!key) throw new Error("LocationIQ key not found in settings response");
        return fetch(`${API_URL}?key=${key}&lat=${latitude}&lon=${longitude}&format=json`);
      })
      .then((res) => {
        if (!res.ok) throw new Error("LocationIQ request failed");
        return res.json();
      })
      .then((data) => {
        if (cancelled) return;
        if (data?.display_name) {
          const firstThree = data.display_name
            .split(",")
            .map((part) => part.trim())
            .slice(0, 3)
            .join(", ");

          const cityState = [
            data.address?.city || data.address?.town || data.address?.village,
            data.address?.state,
          ]
            .filter(Boolean)
            .join(", ");

          setLocality(`${firstThree}, ${cityState}`);
          setStatus("success");
        }
         else {
          setLocality("");
          setStatus("error");
          setError("Location cannot be fetched");
        }
      })
     .catch((err) => {
       if (!cancelled) {
         setLocality("");
         setStatus("error");
         setError(
           err?.message ||
           err?.data?.message ||
           "Location cannot be fetched"
         );
       }
     });

    return () => { cancelled = true; };
  }, [latitude, longitude]);

  return { locality, status, error, isLoading: status === "loading" };
}